import { usePersistentForm } from '@/modules/forms/hooks/usePersistentForm';
import type { PersistentFormName } from '@/store/commonStore/slices/persistant/usePersistentFormsSlice';

export const PersistentFormTracker = ({
  formName,
}: {
  formName: PersistentFormName;
}) => {
  usePersistentForm(formName);
  return null;
};
